export default __webpack_public_path__ + "static/media/WonderWorkshop.9a0bb3e6.webp";